var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testimonial"},[_c('div',{staticClass:"quote-line"},[_c('div',{staticClass:"quote-box"},[_c('font-awesome-icon',{attrs:{"icon":_vm.faQuoteLeft}})],1),_vm._v(" "),_c('div',{staticClass:"testimonial-text"},[_c('div',{staticClass:"testimonial-date"},[_vm._v(" "+_vm._s(_vm.when)+" ")]),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55db9721","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Testimonial.vue
// module id = null
// module chunks = 